<template>
  <div class="md-layout">
    <md-card>
      <md-card-content>
        <div class="md-layout-item md-size-100 my-3">
          <p>{{ this.$t("extended_exportation.export_title") }}</p>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-33">
            <checkboxMultiSelect
              v-model="gradesSelect.values"
              :label="gradesSelect.label"
              :options="gradesSelect.options"
              trackBy="id"
              displayField="name"
              :style="{ marginTop: '-6px' }"
              :showSelectAll="true"
            ></checkboxMultiSelect>
          </div>
          <div class="md-layout-item md-size-33">
            <date-picker-custom
              :label="$t('extended_exportation.enter_date')"
              v-model="datePicker"
            ></date-picker-custom>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{ $t("common.status") }}</label>
              <md-select v-model="statusSelected" name="status" id="status">
                <md-option
                  v-for="(status, index) in statusList"
                  :key="status.name + index"
                  :value="status.id"
                >
                  {{ $t(status.name) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div class="m-auto">
      <md-button @click="exportPDF()" class="md-warning md-round"
        >{{ $t("communication.send_email") }}
      </md-button>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { Message } from "@/helpers/utils";
import checkboxMultiSelect from "@/components/Base/CheckboxMultiSelect";

export default {
  components: { checkboxMultiSelect },
  data() {
    return {
      gradesSelect: {
        label: this.$t("common.grade"),
        options: [],
        values: []
      },
      datePicker: "",
      statusSelected: "",
      statusList: [
        ...DEFAULT_OPTION_ALL,
        {
          id: "Active",
          name: "common.active"
        },
        {
          id: "Inactive",
          name: "common.inactive"
        }
      ]
    };
  },
  created() {
    this.getGrades();
  },
  methods: {
    async getGrades() {
      let grades = await this.$axios
        .get(service_paths.grades, { limit: 30 })
        .then(response => response.data.data);
      this.gradesSelect.options = grades.map(grade => ({
        id: grade.name,
        name: grade.name
      }));
    },
    exportPDF() {
      let param = {
        status: this.statusSelected,
        grades:
          this.gradesSelect.values.length === this.gradesSelect.options.length
            ? []
            : this.gradesSelect.values,
        status: this.statusSelected
      };
      if (this.datePicker) {
        param.entered = this.datePicker;
      }
      this.$axios
        .get(`${service_paths.export}/schedule-report/pdf`, param)
        .then(res => {
          if (res.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
